module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAM1BMVEUAAAA4w1A4w1ExukU4xFE1wE44xFA4xFA4w1E4xFA4xFA4w082wE84w1A3wlEzv005xFFnUDlCAAAAEHRSTlMAf7cN+Tbv39rCpFcenE8okG/0kQAAAHRJREFUKM/N00sKhEAMRdGK5V+7++5/tY1I8YSn5cCJGeZASEiSqMY9p8t4JUfUOCDErtCIL1TseuA8L6bi30C/uhbOI0ymKt61EK4779m2M1XnEwy5qPPaw1zUOS2A1Dh9pGecR6nzNl1T3ff3JbcmfvJjfxF/EmwnOPeuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/btn-select-b.png
// module id = 523
// module chunks = 0